<template>
  <v-dialog
    content-class="initiate-password-spray-scan-popup"
    :value="visiblePopup"
    @click:outside='onCloseClick'
    @keydown.esc="onCloseClick"
    :width="532"
  >
    <v-card class="popup-wrapper">
      <div class='content'>
        <div class="add-title">
          {{ $t('password.spray.scan.pop.up.title') }}
        </div>
        <text-field
          type="text"
          v-model="corpDomain"
          class="login"
          :label="$t('password.spray.scan.pop.up.label')"
          :placeholder="$t('password.spray.scan.pop.up.placeholder')"
        />
        <div class='buttons'>
          <v-btn
            small
            depressed
            class="cancel-button"
            @click="onCloseClick"
          >
            {{ $t('password.spray.scan.popup.cancel.btn') }}
          </v-btn>
          <v-btn
            small
            depressed
            class="save-button"
            @click='saveClicked'
            :disabled="isDisabled"
            :loading="loadingPasswordSpray"
          >
            {{ $t('initiate.password.spray.scan') }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import TextField from '@/components/common/TextField.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import {mapGetters} from 'vuex';

export default {
  name: 'InitiatePasswordSprayScanPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: {
    TextField,
  },
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
    selectedEmployees: {
      type: Array,
      required: false,
      default: () => [],
    },
    excludedEmployees: {
      type: Array,
      required: false,
      default: () => [],
    },
    allSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      corpDomain: '',
    };
  },
  methods: {
    async onCloseClick() {
      await this.$emit('cancel');
    },
    async saveClicked() {
      await this.$emit('save', this.corpDomain);
    },
  },
  computed: {
    ...mapGetters(['loadingPasswordSpray']),
    isDisabled() {
      return !this.allSelected && !this.selectedEmployees.length;
    },
  },
};
</script>

<style lang="scss" >
@import '~@/assets/styles/design-system';

.initiate-password-spray-scan-popup {
  .popup-wrapper {
    max-width: rem(532);
    padding: $space-8 $space-10;

    .content {
      .add-title {
        text-transform: uppercase;
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: $space-4;
        margin-bottom: $space-4;
      }
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .cancel-button {
        box-sizing: border-box;
        height: $space-8;
        width: rem(86);
        border: none;
        color: var(--text-secondary);
        border-radius: $radius-sm;
        background-color: transparent;
        box-shadow: none;
      }

      .save-button {
        border-radius: $radius-sm;
        border: $border-width-thin solid var(--brand-primary);
        background-color: var(--brand-primary);
        box-shadow: $shadow-sm;
        color: var(--text-inverse);
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-left: $space-2;
      }
    }
  }
}
</style>
